import { useState } from "react";

// import axios from 'axios'
import { useDispatch, useSelector } from "react-redux"
import marvarApi from "../../../../../api/marvarApi"
import { parseNumber } from "helpers"
import { onLogout } from "store"

import { useHelpers } from './useHelpers';
import { useGlobalStates } from './useGlobalStates';
import { useDefaultData } from './useDefaultData';
import { useForm } from './useForm';
import * as useFetchData from './useFetchData';
import { useActions } from './useActions';

export const useFechInitLeases = ({location, paramsURL}) => {

    const dispatch = useDispatch()

    const helpers = useHelpers()

    
    const { user } = useSelector((state) => state.auth) //TODO: Revisar usuario

    // globalStates -------------------------------------------------------------------------------
    const globalStates = useGlobalStates()

    // defaultData --------------------------------------------------------------------------------
    const defaultData = useDefaultData({helpers})

    // Para la modal -------------------------------------------------------
    const { defaultDataModal } = defaultData
    const [ dataModal, setDataModal ] = useState(defaultDataModal)
    const toggle = (_, title, compont, dataRequest) => {
        setDataModal({
            ...defaultDataModal,
            open: !dataModal.open,
            titleModal: title,
            componentModal: compont,
            dataRequest: dataRequest
        })
    }   

    const FormLeases = useForm(defaultData.defaultFormLease)
    const FormDeposit = useForm(defaultData.defaultFormDeposit)
    const FormFiles = useForm(defaultData.defaultFormFiles)
    const ObservationsForm = useForm(defaultData.defaultObservationsForm)

    const Forms = {
        FormLeases,
        FormDeposit,
        FormFiles,
        ObservationsForm
    }


    const defaultFetchParams = { 
        //------------- Generales
        marvarApi, user, dispatch, onLogout, location, paramsURL, parseNumber,
        //------------- globalStates
        // globalStates,
        //------------- defalutData
        defaultData, 
        //------------- Helpers
        // Helpers,
        //------------- Forms
        Forms 
    }



    const fetchAllBanks = useFetchData.useFetchAllBanks({...defaultFetchParams})
    const fetchAllCashRegisters = useFetchData.useFetchAllCashRegisters({...defaultFetchParams})
    const fetchAllCustomers = useFetchData.useFetchAllCustomers({...defaultFetchParams})
    const fetchAllDeposits = useFetchData.useFetchAllDeposits({...defaultFetchParams})
    const fetchAllFiles = useFetchData.useFetchAllFiles({...defaultFetchParams})
    const fetchAllHouses = useFetchData.useFetchAllHouses({...defaultFetchParams})
    const fetchAllLeaseApplications = useFetchData.useFetchAllLeaseApplications({...defaultFetchParams})
    const fetchInfoLease = useFetchData.useFetchInfoLease({...defaultFetchParams})
    const fetchInfoDeposit = useFetchData.useFetchInfoDeposit({...defaultFetchParams})
    const fetchAllObservations = useFetchData.useFetchAllObservations({...defaultFetchParams})
   
    const FetchData = {
        fetchAllBanks,
        fetchAllCashRegisters,
        fetchAllCustomers,
        fetchAllDeposits,
        fetchAllFiles,
        fetchAllHouses,
        fetchAllLeaseApplications,
        fetchInfoLease,
        fetchInfoDeposit,
        fetchAllObservations
    }

    const Actions = useActions({
        marvarApi, toggle, user, parseNumber,
        FetchData,
        globalStates,
        defaultData,
        Forms,
    })

    return Object.freeze({
        //------------- Generales
        dataModal, toggle, user,
        globalStates,
        defaultData,
        FetchData,
        Forms,
        Actions
    })

}